import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';

import PaymentPage from '../../../components/ProductSelectionPage/motorplay/payment';
import { selectCurrentContentFichaPath } from '../../../queries/selectors/contents';
import { selectUserData } from '../../../queries/selectors/user';

import withNoMembershipPurchased from '../../withNoMembershipPurchased';
import { selectClient } from '../../../global-selectors';
import withAuthGuard from '../../withAuthGuard';
import { injectIntl } from 'react-intl';

const mapStateToProps = state => ({
  path: selectCurrentContentFichaPath(state),
  user: selectUserData(state),
  client: selectClient(state)
});

const mapDispatchToProps = (
  (dispatch) => bindActionCreators({
  }, dispatch)
);

export default compose(
  withAuthGuard({ toLoginURL: true }),
  withNoMembershipPurchased,
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(PaymentPage);
